import { Navigate } from "react-router-dom";
import { isIAMOnlyUser } from "./iamTerritoryUtils";

const BlockIAMRoute = ({ children, redirectTo = "/dashboard" }) =>
  isIAMOnlyUser() ? <Navigate to={redirectTo} replace /> : children;

export default BlockIAMRoute;
